/*
  Спорные счета: разные файлы называют разное - выбирает человек.

  Решение владельца 30.09.2026: противоречие называется человеку, и система не
  выбирает. По каждому спору видно, что именно называет каждый файл; кнопка
  «Верно это» оставляет значение этого файла, остальные по счёту откладываются.
  Ошибка выбора стоит здесь же, под списком.

  01.10.2026, проверка перед выкладкой: пока идёт перенос, выбор выключен -
  сервер отказал бы (409); у читалки экрана каждая «Верно это» называет свой
  файл - без этого пять одинаковых кнопок подряд не различить.
*/

import { useCallback, useEffect, useState } from 'react'

import { api } from '../../api/client.js'
import { FACT_TITLES } from '../../api/format.js'
import { Notice } from '../Common.jsx'
import PageBar from '../PageBar.jsx'
import { Lock } from '../AccessContext.jsx'
import usePaging from '../usePaging.js'
import TransferLock from './TransferLock.jsx'

export default function DisputeList({ count, onChosen, locked = false }) {
  const [disputes, setDisputes] = useState([])
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)
  // 21.10.2026: споров по большому портфелю бывают сотни - общая панель страниц.
  // Хук - до раннего return.
  const { rows, bar } = usePaging(disputes)

  const reload = useCallback(() => {
    api.uploadConflicts().then(setDisputes).catch(setError)
  }, [])

  useEffect(() => {
    if (count) reload()
  }, [count, reload])

  const choose = async (dispute, option) => {
    setBusy(true)
    setError(null)
    try {
      await api.chooseUploadValue(dispute.account_number, dispute.fact, option.file_id)
      reload()
      onChosen()
    } catch (failure) {
      setError(failure)
    } finally {
      setBusy(false)
    }
  }

  if (!count) return null
  return (
    <section className="section card">
      <h2 className="section__title">Спорные счета: файлы называют разное</h2>
      {rows.map((dispute) => (
        <div key={`${dispute.account_number}-${dispute.fact}`} className="stack">
          <p>
            Лицевой счёт {dispute.account_number} - {FACT_TITLES[dispute.fact] ?? dispute.fact}:
          </p>
          {dispute.options.map((option) => (
            <div key={option.file_id} className="row row--between">
              <span>
                {option.values.join('; ')} <span className="muted filename">- «{option.filename}»</span>
              </span>
              <Lock>
                <button
                  type="button"
                  className="button button--quiet"
                  disabled={busy || locked}
                  aria-label={`Верно это: ${option.filename}`}
                  onClick={() => choose(dispute, option)}
                >
                  Верно это
                </button>
              </Lock>
            </div>
          ))}
        </div>
      ))}
      <PageBar {...bar} what="споров" />
      <TransferLock locked={locked} />
      <Notice error={error} />
    </section>
  )
}
